import React from 'react';
import MobileInfo from 'features/feature-mobile-info';

const MobilePage = () => {
  return <MobileInfo />;
};

export default MobilePage;
